import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Document14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.75 12.5C12.75 13.1904 12.1904 13.75 11.5 13.75H2.5C1.80964 13.75 1.25 13.1904 1.25 12.5V1.5C1.25 0.809645 1.80964 0.25 2.5 0.25H8.79289C9.12441 0.25 9.44236 0.381696 9.67678 0.616117L12.3839 3.32322C12.6183 3.55764 12.75 3.87559 12.75 4.20711V12.5ZM2.75 12.25V1.75H7.25V5C7.25 5.41421 7.58579 5.75 8 5.75H11.25V12.25H2.75ZM11.1893 4.25H8.75V1.81066L11.1893 4.25Z'
      fill='currentColor'
    />
  </Svg>
);

Document14.displayName = 'Document14';
export default Document14;
